// The site's routes (docs/13 "Pages"). ocs-site serves index.html for each of them, with the
// route's title and description already in its head.
import { Route, Routes } from "react-router";

import { Shell } from "./layout/Shell";
import { About } from "./pages/About";
import { Blog } from "./pages/Blog";
import { Charter } from "./pages/Charter";
import { Community } from "./pages/Community";
import { Home } from "./pages/Home";
import { Learn } from "./pages/Learn";
import { NotFound } from "./pages/NotFound";
import { PortableWorkflows } from "./pages/PortableWorkflows";
import { Post } from "./pages/Post";
import { Privacy } from "./pages/Privacy";
import { Products } from "./pages/Products";
import { DangerScale } from "./pages/tools/DangerScale";
import { GuardSavings } from "./pages/tools/GuardSavings";
import { Meter } from "./pages/tools/Meter";
import { Validator } from "./pages/tools/Validator";
import { Tools } from "./pages/Tools";
import { WorkflowDetail } from "./pages/WorkflowDetail";
import { Workflows } from "./pages/Workflows";

export function App() {
  return (
    <Routes>
      <Route element={<Shell />}>
        <Route index element={<Home />} />
        <Route path="products" element={<Products />} />
        <Route path="workflows" element={<Workflows />} />
        <Route path="workflows/:slug" element={<WorkflowDetail />} />
        <Route path="portable-workflows" element={<PortableWorkflows />} />
        <Route path="learn" element={<Learn />} />
        <Route path="blog" element={<Blog />} />
        <Route path="blog/:slug" element={<Post />} />
        <Route path="tools" element={<Tools />} />
        <Route path="tools/meter" element={<Meter />} />
        <Route path="tools/guard-savings" element={<GuardSavings />} />
        <Route path="tools/danger-scale" element={<DangerScale />} />
        <Route path="tools/validator" element={<Validator />} />
        <Route path="charter" element={<Charter />} />
        <Route path="community" element={<Community />} />
        <Route path="about" element={<About />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
